module.exports = __webpack_public_path__ + "static/expo-band-835f127f0ee4b2df2ab0509383ccaf95.jpg";